module.exports = __webpack_public_path__ + "img/Bluetooth.430599df.png";